import { Modal, Text, Stack, Paper, Group, Title, Rating } from "@mantine/core";

const ModalCareersRatings = ({ opened, onClose, careers }) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={700} size="xl">Carreras valoradas</Text>}
      size="lg"
      radius="md"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 2,
      }}
    >
      <Stack spacing="md">
        {careers?.length > 0 ? (
          careers.map((career, index) => (
            <Paper
              key={index}
              shadow="xs"
              radius="md"
              p="md"
              withBorder
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <Group position="apart" align="flex-start">
                <div>
                  <Title order={4} fw={500}>
                    {career.codigo} - {career.descripcion} - {career.sede}
                  </Title>
                  <Text size="sm" mt="xs">
                    {career.detalle || "Sin descripción"}
                  </Text>
                </div>
                <Rating value={career.puntuacion} count={4} readOnly />
              </Group>
            </Paper>
          ))
        ) : (
          <Text c="dimmed" ta="center">
            No hay carreras disponibles.
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default ModalCareersRatings;